import React from "react"
import { Modal, Button } from "react-bootstrap"

const SubmissionAlert = ({ show, handleClose, message, title }) => {
    return (
        <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            size="lg">
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div dangerouslySetInnerHTML={{ __html: message }} />
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="primary"
                    onClick={handleClose}>
                    OK
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default SubmissionAlert
